// Single source of truth for the widget's design tokens (colours, shadow, fonts).
// Both the chatroom (`.ocw`, renderer.ts) and the chat list (`.ocl`, chatlist.ts)
// build their CSS custom-property blocks from these, so the palette — light and
// dark — lives in exactly one place. Change a colour here and every surface,
// in both light and dark mode, updates together.

const LIGHT: Record<string, string> = {
  accent: '#6c5ce7', accent2: '#4c6fff', bg: '#f4f3fb', card: '#fff', tint: '#eeecfb',
  line: '#e6e2f5', ink: '#221d3a', mut: '#8f8aa8', onaccent: '#fff', rowhover: '#e7e3f8',
  shadow: '0 12px 32px rgba(108,92,231,.14)',
}

const DARK: Record<string, string> = {
  accent: '#a99cf2', accent2: '#6f8cff', bg: '#221d3a', card: '#2b2550', tint: '#2f2853',
  line: '#3a3363', ink: '#eceafc', mut: '#9b93c9', onaccent: '#221d3a', rowhover: '#39325e',
  shadow: '0 12px 32px rgba(0,0,0,.4)',
}

const FB = "'Nunito',-apple-system,BlinkMacSystemFont,'Segoe UI',system-ui,sans-serif"

function vars(prefix: string, t: Record<string, string>): string {
  return Object.entries(t).map(([k, v]) => `--${prefix}-${k}:${v};`).join(' ')
}

/** Light-mode token declarations for a prefix ('ocw' | 'ocl'), incl. font tokens. */
export function lightTokens(prefix: string): string {
  return `${vars(prefix, LIGHT)} --${prefix}-fb:${FB}; --${prefix}-fh:'Baloo 2',var(--${prefix}-fb);`
}

/** Dark-mode token overrides for a prefix (fonts are unchanged in dark). */
export function darkTokens(prefix: string): string {
  return vars(prefix, DARK)
}
